import { z } from 'zod';
import { api } from '../../lib/api';

const component = z.object({
  id: z.string(), name: z.string(), group: z.enum(['flow', 'brain', 'model', 'tool', 'adapter']), purpose: z.string(),
  development: z.enum(['implemented', 'contract', 'planned']),
  activation: z.enum(['configured', 'disabled', 'unknown', 'not_applicable']), activationNote: z.string(), permission: z.string(),
  observation: z.enum(['not_captured', 'not_applicable']), evidence: z.array(z.object({ path: z.string(), symbol: z.string() })),
  roles: z.array(z.string()).optional(), tool: z.object({ operationId: z.string(), modelName: z.string(),
    effect: z.enum(['read', 'write', 'client_action']), dataClass: z.string(), policyId: z.string(), connection: z.enum(['native', 'contract']) }).optional(),
});
export const inventorySchema = z.object({
  schemaVersion: z.literal('ai-system.inventory.v1'), inventoryVersion: z.string(), generatedAt: z.string().datetime(),
  product: z.enum(['currivium', 'psychotherapie', 'currivium-ai']), channel: z.enum(['text', 'voice']),
  environment: z.enum(['production', 'staging', 'development']), environmentSource: z.enum(['APP_ENV', 'NODE_ENV']),
  availability: z.enum(['inventory', 'planned', 'not_connected']), components: z.array(component),
  edges: z.array(z.object({ from: z.string(), to: z.string(), relation: z.string(), development: z.enum(['implemented', 'planned']) })), notes: z.array(z.string()),
});
export type Inventory = z.infer<typeof inventorySchema>;
export type Component = z.infer<typeof component>;
export type Product = Inventory['product'];
export type Channel = Inventory['channel'];
export async function fetchInventory(product: Product, channel: Channel, signal?: AbortSignal): Promise<Inventory> {
  const result = inventorySchema.parse(await api.get<unknown>(`/admin/ai-system/inventory?${new URLSearchParams({ product, channel })}`, { signal }));
  if (result.product !== product || result.channel !== channel) throw new Error('Die Antwort gehört zu einem anderen Produkt oder Kanal.');
  return result;
}

export const DEVELOPMENT = { implemented: 'Implementiert', contract: 'Vertrag vorhanden', planned: 'Geplant' };
export const ACTIVATION = { configured: 'Konfiguriert', disabled: 'Schalter aus / Katalog deaktiviert', unknown: 'Unbekannt', not_applicable: 'Nicht anwendbar' };
